import type { ReactNode } from 'react'
import { cn } from '@shared/lib/cn'
import { BadgeVariant } from './types'

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant
  iconLeft?: ReactNode
  iconRight?: ReactNode
}

const variantClasses: Record<BadgeVariant, string> = {
  [BadgeVariant.gray]: 'bg-surface text-secondary border-border',
  [BadgeVariant.green]: 'bg-green-subtle text-green border-border',
  [BadgeVariant.orange]: 'bg-orange-subtle text-orange border-border',
  [BadgeVariant.red]: 'bg-red-subtle text-red border-border',
  [BadgeVariant.violet]: 'bg-violet-subtle text-violet border-border',
  [BadgeVariant.blue]: 'bg-blue-subtle text-blue border-border',
}

export function Badge({
  className,
  variant = 'gray',
  iconLeft,
  iconRight,
  children,
  ...props
}: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2 py-0.75 text-xs',
        variantClasses[variant],
        className
      )}
      {...props}
    >
      {iconLeft}
      {children}
      {iconRight}
    </span>
  )
}
